import { defineStore } from 'pinia'
export const useMainStore = defineStore('main', {
  state: () => ({
    isNavOpen: false,
    isSearchOpen: false,
    isMobile: window.innerWidth < 769,
    isDetached: false,
    isAttached: true,
    loader: false,
    headerClicked: true,
    gotoJob: false
  }),
  actions: {
    toggleNav () {
      this.isNavOpen = !this.isNavOpen
    },
    toggleReferralNav () {
      this.isNavOpen = false
    },
    toggleSearch () {
      this.isSearchOpen = !this.isSearchOpen
    },
    getScreenSize () {
      this.isMobile = window.innerWidth < 769
    },
    handleScroll () {
      this.isAttached = window.scrollY < window.innerHeight / 2
      this.isDetached = window.scrollY > window.innerHeight / 3
    },
    detachTitle () {
      this.isDetached = window.scrollY > window.innerHeight / 3
    },
    loaderView (value) {
      this.loader = value
    }
  }
})
